import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";

import { styled } from "styled-components";
import { CheckoutFormInput } from "./CardsCheckoutForm";
import CheckoutPage from "./CardsCheckoutPage";
import { Loader } from "@aws-amplify/ui-react";

const StripeWrapper = styled(Elements)`
    width: 100%;
`;

export function Cards({
    description,
    amount,
    clientSecret,
    stripeConnect,
    onSuccess,
}: CheckoutFormInput) {
    const [displayCards, setDisplayCards] = useState(false);
    const [stripePromise, setStripePromise] = useState<Promise<Stripe | null>>(async () => null);

    const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

    useEffect(() => {
        console.log("[Cards]", { amount });
        setDisplayCards(Boolean(amount));
    }, [amount]);

    useEffect(() => {
        if (!stripePublishableKey || !stripeConnect || !amount || !clientSecret) {
            return;
        }
        setStripePromise(() => loadStripe(stripePublishableKey));
    }, [stripePublishableKey, stripeConnect, amount, clientSecret]);

    if (!stripePublishableKey || !stripeConnect || !amount) {
        return null;
    }

    if (!displayCards) {
        return null;
    }

    if (!clientSecret) {
        return <Loader size="large" variation="linear" />;
    }

    return (<>{
        stripePromise && < StripeWrapper stripe={stripePromise} options={{
            mode: 'payment',
            amount: amount,
            currency: 'gbp',
            // @ts-ignore
            onBehalfOf: stripeConnect
        }}>
            <CheckoutPage onSuccess={onSuccess} clientSecret={clientSecret} />
        </StripeWrapper >
    }</>);
}
